<template>
  <component :is="`h${size}`">
    <slot></slot>
  </component>
</template>
<script>
  export default {
    name: 'w-title',
    props: {
      size: {
        default: 1,
        validator(value) {
          return [1, 2, 3, 4, 5, 6].indexOf(parseInt(value.toString())) !== -1;
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: $neutral-black;
    font-weight: bold;
  }
  h1 {
    font-size: 24px;
    line-height: 28px;
  }
  h2 {
    font-size: 22px;
    line-height: 26px;
  }
  h3 {
    font-size: 20px;
    line-height: 24px;
  }
  h4 {
    font-size: 18px;
    line-height: 24px;
  }
  h5 {
    font-size: 14px;
    line-height: 18px;
  }
  h6 {
    font-size: 10px;
    line-height: 12px;
  }

  *.semi-bold {
    font-weight: 600;
  }
</style>
